import { z } from "zod";
import { isValidTime, isGreaterThanTime } from "../../../../../../../../../../../utils/timeValidate";

export const schema = z.object({
    setor: z.string().min(1, { message: "Setor é obrigatório" }),
    dia_semana: z.string().min(1, { message: "Dia da semana é obrigatório" }),
    ativo: z.boolean().default(false),
    hora_inicio: z.string().min(5, { message: "Hora de início da manhã é obrigatória" }),
    hora_fim: z.string().min(5, { message: "Hora de fim da tarde é obrigatória" }),
    intervalo_hora_inicio: z.string().optional(),
    intervalo_hora_fim: z.string().optional(),
    motivo_inativo: z.string().nullable(),
}).superRefine((data, ctx) => {
    if (!data.ativo && !data.motivo_inativo) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Motivo é obrigatório quando o horário/dia não está ativo",
            path: ["motivo_inativo"],
        });
    }

    if (!isValidTime(data.hora_inicio)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Hora de início deve ser válida",
            path: ["hora_inicio"],
        });
    }

    if (!isValidTime(data.hora_fim)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Hora de fim deve ser válida",
            path: ["hora_fim"],
        });
    }

    if (!isGreaterThanTime(data.hora_fim, data.hora_inicio)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Fim do agendamento deve ser maior que o início",
            path: ["hora_fim"],
        });
    }

    if (data.intervalo_hora_inicio || data.intervalo_hora_fim) {
        if (!isValidTime(data.intervalo_hora_inicio)) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: "Hora de início do intervalo deve ser válida",
                path: ["intervalo_hora_inicio"],
            });
        }

        if (!isValidTime(data.intervalo_hora_fim)) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: "Hora de fim do intervalo deve ser válida",
                path: ["intervalo_hora_fim"],
            });
        }

        if (!isGreaterThanTime(data.intervalo_hora_fim, data.intervalo_hora_inicio)) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: "Fim do intervalo deve ser maior que o início",
                path: ["intervalo_hora_fim"],
            });
        }
    }
});
